export const ADD_CHAPTER = 'addChapter';
export const ADD_LOGO = 'addLogo';
export const DELETE_CHAPTER = 'deleteChapter';
export const DELETE_LOGO = 'deleteLogo';
export const EDIT_CHAPTER = 'editChapter';
export const EDIT_THEME = 'editTheme';
